module.exports = __webpack_public_path__ + "static/media/flag.11bcbcde.svg";